import Uiconstants from '../../lib/UIconstants';
import DoubleChanceController from '../../controllers/double_chance/DoubleChanceController';
import { COMPONENTS } from '../../lib/constants';
// import { isDesktop } from "react-device-detect";

// let position = {
//   activeBot: {
//     x: isDesktop ? -27 : -27,
//     y: isDesktop ? 86 : 86,
//   },
//   passiveBot: {
//     x: isDesktop ? -26 : -26,
//     y: isDesktop ? 124 : 86,
//   },
//   activeTop: {
//     x: isDesktop ? -23 : -23,
//     y: isDesktop ? -24 : -26,
//   },
//   passiveTop: {
//     x: isDesktop ? -24 : -24,
//     y: isDesktop ? -24 : -26,
//   },
// };

// let scale = 0.65;

export const DoubleChanceWidgetMobile = {
	name: COMPONENTS.DOUBLE_CHANCE_WIDGET,
	tmp: 'mobile',
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: DoubleChanceController,
			name: 'DoubleChanceController',
			config: {
				item: Uiconstants.FTR_DOUBLE_CHANCE,
				holder: 'double_chance_widget_holder_up'
			}
		}
	],
	components: [
		{
			name: 'double_chance_widget_holder_up',
			type: 'Sprite',
			position: { x: 0, y: 0 },
			components: [
				{
					name: 'double_wrapper',
					type: 'SimpleButton',
					components: [
						{
							name: 'double_chance_widget_bg_mobile',
							type: 'MouseOverSprite',
							img: 'bonus_buy_widget_bg',
							imgHover: 'bonus_buy_widget_bg_hovered',
							cursor: 'default',
							position: { x: 20, y: -20 },
							components: [
								{
									name: Uiconstants.FTR_DOUBLE_CHANCE,
									type: 'SwitchButton',
									bgimg: 'switcher_btn_on',
									bg: 'switcher_back_on',
									fgimg: 'switcher_btn_off',
									fg: 'switcher_back_on',
									bgText: 'DOUBLE_CHANCE_SWITCHER_ON',
									fgText: 'DOUBLE_CHANCE_SWITCHER_OFF'
								}
							]
						},
						{
							name: 'border',
							type: 'Sprite',
							img: 'bonus_border',
							position: { x: 0, y: -2 }
						},
						{
							name: 'DOUBLE_CHANCE_VALUE',
							type: 'Text',
							position: { x: 27, y: 12 },
							text: 'DOUBLE_CHANCE_VALUE'
						},
						{
							name: 'DOUBLE_CHANCE_TITLE',
							type: 'Text',
							position: { x: 27, y: 55 },
							text: 'DOUBLE_CHANCE_TITLE'
						},
						{
							name: 'DOUBLE_CHANCE_CURRENCY',
							type: 'Text',
							position: { x: 27, y: 25 },
							text: 'DOUBLE_CHANCE_CURRENCY'
						},
						{
							name: 'DOUBLE_CHANCE_SUBTITLE',
							type: 'Text',
							position: { x: 93, y: 80.5 - 13 },
							text: 'DOUBLE_CHANCE_SUBTITLE'
						}
					]
				}
			]
		}
	]
};
